import * as React from 'react';
import { AssetLinks } from '@assets/assets';
import { FieldWrapperPassThroughProps } from './FieldWrapper';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> &
  FieldWrapperPassThroughProps & {
    className?: string;
    isLabelTextWrap?: boolean;
  };

const CheckInput = React.forwardRef<HTMLInputElement, InputProps>(({ className, label, isLabelTextWrap, ...props }, ref) => {
  return (
    <label
      htmlFor={label}
      className={`${
        isLabelTextWrap ? 'iLendingCDX-checkbox-wrap-container' : 'iLendingCDX-checkbox-container'
      } iLendingCDX-input-label ${className}`}
    >
      <input
        ref={ref}
        type="checkbox"
        className={`${isLabelTextWrap ? 'iLendingCDX-wrap-checkmark' : 'iLendingCDX-checkmark'}`}
        id={label}
        aria-checked={props.checked}
        aria-label={label}
        {...props}
      />
      <span
        className={`${isLabelTextWrap ? 'iLendingCDX-wrap-checkmark' : 'iLendingCDX-checkmark'}`}
        aria-hidden="true"
      >
        <img
          src={AssetLinks?.tickwhite}
          alt=""
          className="iLendingCDX-checkmark-icon"
        />
      </span>
      {label}
    </label>
  );
});

export { CheckInput };
